<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                        <v-autocomplete :disabled="!channelsDropDown.length" v-model="channel" :items="channelsDropDown" @change="channelOnChange" label="Select a channel"></v-autocomplete>
                    </v-flex>

                    <v-flex xs4></v-flex>

                    <v-flex xs4>
                        <v-select :disabled="!channel" v-model="paymentType" :items="paymentOptions" label="Payment Type"></v-select>
                    </v-flex>
                </v-layout>

                <v-layout row wrap id="form-container">
                    <v-flex xs12>
                        <payment-form v-if="channel && (paymentType == 1 || paymentType == 2 || paymentType == 3)" :selectedChannel="selectedChannel" :paymentType="paymentType" :addresses="addresses"></payment-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
  import PaymentForm from '../components/PaymentForm.vue';
  import sweetAlert from '../sweetAlert.js';
  import axios from 'axios';

  export default {
    data () {
      return {
        channel: null,
        channels: [],
        channelsDropDown: [],
        selectedChannel: [],
        paymentType: null,
        paymentOptions: [
          { value: 1, text: 'Payment' },
          { value: 2, text: 'Preauthorize' },
          { value: 3, text: 'Registration' }
        ],
        resourcePath: null,
        addresses: [],
        resultCodesSuccess: ['000.000.000', '000.000.100', '000.100.110', '000.100.111', '000.100.112', '000.300.000', '000.300.100', '000.300.101', '000.300.102', '000.600.000'],
        resultCodesManuallyReview: ['000.400.000', '000.400.010', '000.400.020', '000.400.040', '000.400.050', '000.400.060', '000.400.070', '000.400.080', '000.400.090', '000.400.100'],
        resultCodesPending: ['000.200.000', '000.200.100', '000.200.101', '000.200.102', '000.200.200', '100.400.500', '800.400.500', '800.400.501', '800.400.502'],
      }
    },
    components: {
      'payment-form' : PaymentForm
    },
    mixins: [ sweetAlert ],
    beforeMount() {
      this.getPaymentStatusPath();
      this.getAddresses();
      this.getChannels();
    },
    methods: {
      getChannels() {
        axios({
          method: 'post',
          url: 'https://controlapi.totalprocessing.com/api/client-get-channels',
          data: { userId: localStorage.user_id },
          config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
          })
          .then(response => {
            this.channels = response.data;
            response.data.forEach((item) => {
              this.channelsDropDown.push({value: item['entityId'], text: item['divisionName'] + " - " + item['merchantName'] + " - " + item['entityName']});
            });
          })
          .catch(e => {
            this.errors.push(e)
          })
      },

      getPaymentStatusPath() {
        this.resourcePath = decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('resourcePath').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
        this.getPaymentStatus();
      },

      getPaymentStatus() {
        if(this.resourcePath.includes('/v1/checkouts/')) {
          axios({
          method: 'post',
          url: 'https://controlapi.totalprocessing.com/api/get-payment-status',
          data: { resourcePath: this.resourcePath },
          config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
          })
          .then(response => {
            console.log(response.data);
            this.sweetAlert(response.data);
          })
          .catch(e => {
            this.errors.push(e)
          })
        }
      },

      channelOnChange(value) {
        let channel = this.channels.filter(obj => {
          return obj.entityId === value
        });

        let currencies = [];

        if(channel[0]['currencies'] != null) {
          channel[0]['currencies'].split(",").forEach((item) => {
            currencies.push({ value: item, text: item });
          });
        }
        else {
          currencies.push({value: 'GBP', text: 'GBP' });
        }

        this.selectedChannel = {entityId: channel[0]['entityId'], userId: channel[0]['userId'], password: channel[0]['password'], url: 'oppwa.com', currencies: currencies};
      },

      getAddresses() {
        axios({
          method: 'get',
          url: 'https://controlapi.totalprocessing.com/api/get-addresses',
          data: { resourcePath: this.resourcePath },
          config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
          })
          .then(response => {
            this.addresses = response.data;
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    }
  }
</script>

<style>
    #form-container {
        margin-top: 0px;
    }
</style>
